import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6579e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-container_article-image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "news-container_article-content" }
const _hoisted_4 = {
  key: 0,
  class: "article-subtitle"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Read Full Article", -1))

import { ref, watchEffect } from "vue";
import { format } from "date-fns";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsCard',
  props: {
  imgUrl: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const formattedDate = ref(format(new Date(props.date), "MMMM dd, yyyy"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "news-container_article",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.imgUrl,
        class: "article-image",
        alt: "Article Image"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(formattedDate.value), 1),
        _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
        (__props.subtitle)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(__props.subtitle), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ])
  ]))
}
}

})